import { atom } from 'recoil';

import { RECOIL_ATOM_KEYS } from '../recoilKey';

export const selectSquareBtnColorState = atom({
  key: RECOIL_ATOM_KEYS.SELECT_SQUARE_BTN_COLOR, // unique ID (with respect to other atoms/selectors)
  default: [["#ffffff", "#555555"], ["#ffffff", "#555555"], ["#ffffff", "#555555"]], // default value (aka initial value)
});
